import { cn } from '@theprintbar/shared';
import React, { useState } from 'react';
import { Modal } from '../Modal';

export interface UseConfirmModalProps<T> {
	content: React.ReactNode;
	actionContainerClassName?: string;
	actions: Array<{
		//Button is an element we can render with the onClick function
		ActionButton: (onClick: () => void) => React.ReactNode;
		onClick: () => T;
	}>;
	className?: string;
}

export function useConfirmModal<T>({ content, actions, actionContainerClassName, className }: UseConfirmModalProps<T>) {
	const [resolvePromise, setResolvePromise] = useState<((value: T) => void) | null>(null);

	const confirm = () => {
		return new Promise<T>(resolve => {
			setResolvePromise(() => resolve);
		});
	};

	const handleClick = (action: () => T) => {
		resolvePromise?.(action());
		setResolvePromise(null);
	};

	const ConfirmModal = () => {
		return (
			<Modal open={!!resolvePromise} className={className}>
				{content}
				<div className={cn('flex justify-between items-center', actionContainerClassName)}>
					{actions.map(({ ActionButton, onClick }) => ActionButton(() => handleClick(onClick)))}
				</div>
			</Modal>
		);
	};

	return { confirm, ConfirmModal };
}

export default useConfirmModal;
